

// let elementsByClassName = document.getElementsByClassName('motors-section');
// for (const section of elementsByClassName) {
//     for (let img of section.querySelectorAll('img')) {
//         img.addEventListener('click', (e) => {
//             let popover = document.getElementById('img-prev');
//             popover.showPopover();
//         })
//     }
// }